// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"mIqNB","rc-tabs-tab":"-sAVZ","rc-tabs-tab-active":"EvcNc","tip":"WeiGh","tip-label":"g1HbA","tip-group":"fmQBj","invalidItem":"_6Ur69"};